import { useMemo } from "react";

import { useSelector } from "react-redux";

import useContactsCountByCountries from "app/pages/sales-intelligence/modules/company-analysis/queries/useContactsCountByCountries";
import { selectCurrentCountriesIds } from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/selectors";

const EMPTY_COUNTRIES_IDS: number[] = [];

export function useSelectedAvailableCountries() {
    const { data: countries, isLoading, isPlaceholderData } = useContactsCountByCountries();
    const selectedIds = useSelector(selectCurrentCountriesIds);

    const selectedCountriesIds = useMemo(() => {
        if (!countries) {
            return EMPTY_COUNTRIES_IDS;
        }

        const availableIdsSet = new Set(countries.map((c) => c.id));
        const filtered = selectedIds.filter((id) => availableIdsSet.has(id));

        return filtered.length === 0 ? EMPTY_COUNTRIES_IDS : filtered;
    }, [selectedIds, countries]);

    return {
        selectedCountriesIds,
        isLoading,
        isCountriesTransitioning: isLoading || isPlaceholderData,
        availableCountries: countries ?? [],
    };
}
